<div class="form-builder-field-editor">
  <div class="form-builder-field-editor-header">
    <button class="btn-tool-back">
      <div class="icon-back"></div>
    </button>
    <h4 class="form-builder-field-editor-header-title">Edit Field</h4>
  </div>

  {{#if template.label}}
    <div class="form-field">
      <label class="control-label" for="form-field-label">Label</label>
      <input data-field-text-attribute="label" id="form-field-label" type="text" placeholder="{{ template.label.placeholder }}" value="{{ field.label }}">
    </div>
  {{/if}}

  {{#if template.submit}}
    <div class="form-field">
      <label class="control-label" for="submit_button_text">Label</label>
      <input data-field-text-attribute="submit" id="submit_button_text" type="text" value="{{ field.submit }}">
    </div>
  {{/if}}

  {{#if template.placeholder}}
    <div class="form-field">
      <label class="control-label" for="form-field-placeholder">Placeholder</label>
      <input data-field-text-attribute="placeholder" id="form-field-placeholder" type="text" value="{{ field.placeholder }}">
    </div>
  {{/if}}

  {{#if template.name}}
    <div class="form-field">
      <label class="control-label" for="form-field-name">Field Name</label>
      <input data-field-text-attribute="name" id="form-field-name" type="text" value="{{ field.name }}">
    </div>
  {{/if}}

  {{#if template.value}}
    <div class="form-field">
      <label class="control-label" for="form-field-value">Value</label>
      <input data-field-text-attribute="value" id="form-field-value" type="text" value="{{ field.value }}">
    </div>
  {{/if}}

  {{#if template.text}}
    <div class="form-field">
      <label class="control-label" for="form-field-text">Text</label>
      <textarea data-field-text-attribute="text" id="form-field-text">{{ field.text }}</textarea>
    </div>
  {{/if}}

  {{#if template.content}}
    <div class="form-field">
      <div data-wysiwyg="true" data-wysiwyg-spacing="public" data-field-wysiwyg-attribute="content" class="editor-container">
        {{{ field.content }}}
      </div>
    </div>
  {{/if}}

  {{#if template.required}}
    <div class="form-field">
      <label class="switch">
        <input data-field-boolean-attribute="required" type="checkbox" class="form-field-required" {{#if field.required}}checked="checked"{{/if}}>
        <div class="slider"></div>
        <span>Required</span>
      </label>
    </div>
  {{/if}}

   {{#if template.max_length}}
    <div class="form-field">
      <label class="switch">
        <input data-field-boolean-attribute="max_length" type="checkbox" class="form-field-max_length" {{#if field.max_length}}checked="checked"{{/if}}>
        <div class="slider"></div>
        <span>Limit field to character count</span>
      </label>
    </div>

    <div class="form-field">
      <label class="control-label" for="form-field-limit_size">Max character limit</label>
      <input data-field-text-attribute="limit_size" id="form-field-limit_size" type="number" value="{{#if field.limit_size}}{{ field.limit_size }}{{ else }}{{ template.limit_size }}{{/if}}">
    </div>
  {{/if}}

  {{#if template.collapsed}}
    <div class="form-field">
      <label class="switch">
        <input data-field-boolean-attribute="collapsed" type="checkbox" class="form-field-required" {{#if field.collapsed}}checked="checked"{{/if}}>
        <div class="slider"></div>
        <span>Collapsed by default</span>
      </label>
      <span class="comment">Inner content is hidden until the user toggles</span>
    </div>
  {{/if}}

  {{#if template.traits}}
    <div class="form-field">
      <label class="control-label" for="form-field-text">Trait</label>
      {{sp_select_tag "" dataFieldTextAttribute="trait_id" choices=(lookup selectItems "trait_id") selected=field.trait_id searchable=(lookup template.select_searchable "trait_id")}}
    </div>
  {{/if}}

  {{#if template.patient_contact_relationship_types}}
    <div class="form-field">
      <label class="control-label" for="form-field-text">Relationship Type</label>
      {{sp_select_tag "" dataFieldTextAttribute="patient_contact_relationship_type_id" choices=(lookup selectItems "patient_contact_relationship_type_id") selected=field.patient_contact_relationship_type_id searchable=(lookup template.select_searchable "patient_contact_relationship_type_id")}}
    </div>
  {{/if}}

  {{#if template.size_options}}
    <div class="form-field">
      <label class="control-label" for="form-field-text">Display Size</label>
      {{sp_select_tag "" dataFieldTextAttribute="size" choices=(lookup selectItems "size") selected=field.size searchable=(lookup template.select_searchable "size")}}
    </div>
  {{/if}}

  {{#if template.display_style}}
    <div class="form-field">
      <label class="control-label" for="form-field-text">Display Style</label>
      {{sp_select_tag "" dataFieldTextAttribute="display_style" choices=(lookup selectItems "display_style") selected=field.display_style searchable=(lookup template.select_searchable "display_style")}}
    </div>
  {{/if}}

  {{#if template.template_options}}
    <div class="form-field">
      <label class="control-label" for="form-field-text">Options</label>
      {{sp_select_tag "" dataFieldTextAttribute="template_option" choices=(lookup selectItems "template_option") selected=field.template_option searchable=(lookup template.select_searchable "template_option")}}
    </div>
  {{/if}}

  {{#if template.options}}
    <div class="form-field">
      <label class="control-label">Options</label>
      <div class="form-field-options" data-field-multiple-attribute="options">
        {{#each field.options}}
          <div class="form-field form-field-option">
            <input class="form-field-option-value" type="text" value="{{ this }}">
            <button class="btn-tool btn-tool-delete-option">
              {{{ icon "close-alt-color" }}}
            </button>
          </div>
        {{/each}}
      </div>
      <button class="btn-tool btn-tool-add-option">
        {{{ icon "add-alt-color" }}}  Add Option
      </button>
    </div>
  {{/if}}

  {{#if template.static_options}}
    <div class="form-field">
      <label class="control-label">Options</label>
      <div class="form-field-options" data-field-multiple-attribute="static_options">
        {{#each field.static_options}}
          <div class="form-field form-field-option">
            {{#if label}}<label class="form-field-option-label">{{label}}</label>{{/if}}
            <input class="form-field-option-value" type="text" {{ spread this except="label" }} />
          </div>
        {{/each}}
      </div>
    </div>
  {{/if}}

  {{#if template.revealing_options}}
    <div class="form-field">
      <label class="control-label">Options</label>
      <div class="form-field-options" data-field-multiple-nested-attribute="revealing_options">
        {{#each field.revealing_options}}
          <div class="form-field form-field-option" data-field-attribute-container>
            <input data-field-attribute-input="value" class="form-field-option-value" type="text" value="{{ this.value }}">
            <button class="btn-tool btn-tool-delete-option">{{{ icon "close-alt-color" }}}</button>
            <div data-wysiwyg="true" data-field-attribute-input="content" class="editor-container">
              {{{ this.content }}}
            </div>
          </div>
        {{/each}}
      </div>
      <button class="btn-tool btn-tool-add-option">{{{ icon "add-alt-color" }}} Add Option</button>
    </div>
  {{/if}}

  {{#if template.dispositions}}
    <div class="form-field">
      <label class="control-label">Options</label>
      <div class="form-field-options" data-field-multiple-nested-attribute="dispositions">
        {{#each field.dispositions}}
          <div class="form-field form-field-option" data-field-attribute-container>
            <input data-field-attribute-input="label" class="form-field-option-value" type="text" value="{{ this.label }}" placeholder="Label">
            {{sp_select_tag "" dataFieldAttributeInput="value" choices=(lookup ../selectItems "dispositions") selected=this.value searchable=(lookup ../template.select_searchable "dispositions")}}
            <button class="btn-tool btn-tool-delete-option">{{{ icon "close-alt-color" }}}</button>
          </div>
        {{/each}}
      </div>
      <button class="btn-tool btn-tool-add-option">{{{ icon "add-alt-color" }}} Add Option</button>
    </div>
  {{/if}}
  {{#if template.journey_subjects}}
    <div class="form-field">
      <label class="control-label">Options</label>
      <div class="form-field-options" data-field-multiple-nested-attribute="journey_subjects">
        {{#each field.journey_subjects}}
          <div class="form-field form-field-option" data-field-attribute-container>
            <input data-field-attribute-input="label" class="form-field-option-value" type="text" value="{{ this.label }}" placeholder="Label">
            {{sp_select_tag "" dataFieldAttributeInput="value" choices=(lookup ../selectItems "journey_subjects") selected=this.value searchable=(lookup ../template.select_searchable "journey_subjects")}}
            <button class="btn-tool btn-tool-delete-option">{{{ icon "close-alt-color" }}}</button>
          </div>
        {{/each}}
      </div>
      <button class="btn-tool btn-tool-add-option">{{{ icon "add-alt-color" }}} Add Option</button>
    </div>
  {{/if}}
</div>

{{#unless template.submit}}
  <div class="field-editor-info">
    <div class="field-editor-info-header field-editor-info-header-toggled" data-behaviour="toggleable" data-toggle-class="field-editor-info-header-toggled" data-target=".field-editor-info-content">
      <div class="field-editor-info-header-icon">
        {{{ icon 'info-filled' }}}
        </div>
      <h4 class="field-editor-info-header-title">Info &amp; Actions</h4>
      <div class="field-editor-info-header-toggle"></div>
    </div>
    <div class="field-editor-info-content" style="display: none;">
      <p class="field-editor-info-content-type">Type: {{type}}</p>
      <button class="field-editor-info-content-delete btn-tool-delete">
        {{{ icon 'close-alt-color' }}}
        Delete This Field
      </button>
    </div>
  </div>
{{/unless}}
